import logLevel from 'loglevel';

import { Constants } from './Constants';
import { Util } from './Util';

export class Logger {
	private readonly _fileName: string;

	constructor(fileName: string) {
		this._fileName = fileName;
		this._setLogLevel();
	}

	get fileName() {
		return this._fileName;
	}

	public log(message: string) {
		logLevel.log(this._getMessage(message));
	}

	public info(message: string) {
		logLevel.info(this._getMessage(message));
	}

	public warn(message: string) {
		logLevel.warn(this._getMessage(message));
	}

	public error(message: string) {
		logLevel.error(this._getMessage(message));
	}

	public logError(error: Error) {
		logLevel.error(error);
	}

	private _getMessage(message: string) {
		return `Date: ${Date()} \nMessage: ${message} \nFile: ${this.fileName}`;
	}

	private _setLogLevel() {
		const isDebugModeActivated =
			Util.isUrlParamDefined(Constants.URL_PARAM_DEBUG_MODE) || Util.isUrlParamDefined(Constants.URL_PARAM_UI5_DEBUG_MODE);
		if (isDebugModeActivated) {
			logLevel.setLevel(0);
		} else {
			logLevel.setLevel(3);
		}
	}
}
